























































import Vue from 'vue';
import CustomerHelper from '../../helpers/CustomerHelper';
import OldCartHelper from '../../helpers/OldCartHelper';
import ProductListMixins from '../../mixins/ProductListMixins';
import CookieHelper from '../../helpers/CookieHelper';
import PriceMethods from '../../methods/PriceMethods';
import OldFormatHelper from '../../helpers/OldFormatHelper';
import DataLayerHelper from '../../helpers/DataLayerHelper';
import { IProduct } from '../../common/interfaces/products.interface';

interface ISingleProductComplementComponent {
  formatHelper: typeof OldFormatHelper;
  initialized: boolean;
  isPartner: boolean;
  loading: boolean;
}

export default Vue.extend({
  mixins: [ProductListMixins],
  data(): ISingleProductComplementComponent {
    return {
      formatHelper: OldFormatHelper,
      initialized: false,
      isPartner: false,
      loading: false,
    };
  },
  props: {
    limitingActive: {
      default: false,
      type: Boolean,
    },
    productInfo: {
      required: true,
      type: Object as () => IProduct,
    },
    shoppingAllowed: {
      default: true,
      type: Boolean,
    },
    t: {
      default: () => {},
      type: Object as () => unknown,
    },
  },
  methods: {
    ...PriceMethods,
    async addItemToCart(matchcode: string): Promise<void> {
      this.loading = true;
      const cartId = CookieHelper.getLastUsedCartId();

      const body: { amount: number; cartId?: number; matchcode: string} = { amount: 1, matchcode };

      if(cartId) {
        body.cartId = cartId;
      }

      await OldCartHelper.addItemToCart(body);

      const atcProducts = {
        id: this.productInfo.matchcode,
        name: this.productInfo.title,
        price: this.getMyPriceUnformatted(),
        quantity: 1,
      };
      DataLayerHelper.setProductInfoOnAddToCartToGtm(atcProducts);
      this.loading = false;
    },
    async checkPartnerStatus(): Promise<void> {
      this.isPartner = await CustomerHelper.getPartnerStatus();
    },
  },
});
